<template>
  <div class="home-banner-page">
    <!-- 顶部工具条 -->
    <div class="toolbar">
      <el-input
        v-model="keyword"
        placeholder="按标题搜索"
        clearable
        style="width: 220px"
        @keyup.enter.native="loadList"
      ></el-input>
      <el-button type="primary" icon="el-icon-search" @click="loadList">搜索</el-button>
      <el-button type="success" icon="el-icon-plus" style="float: right" @click="openDialog()">新增 Banner</el-button>
    </div>

    <!-- 列表 -->
    <el-table :data="tableData" border stripe v-loading="loading" style="margin-top: 10px">
      <el-table-column label="ID" prop="id" width="70"></el-table-column>
      <el-table-column label="图片" width="140">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.image"
            :src="scope.row.image.startsWith('/')?`${baseURL}${scope.row.image}`:scope.row.image.startsWith('http')?`${scope.row.image}`:`${baseURL}/${scope.row.image}`"
            fit="cover"
            style="width: 100px; height: 60px; border-radius: 4px"
            :preview-src-list="[scope.row.image.startsWith('/')?`${baseURL}${scope.row.image}`:scope.row.image.startsWith('http')?`${scope.row.image}`:`${baseURL}/${scope.row.image}`]"
          ></el-image>
          <span v-else>无图</span>
        </template>
      </el-table-column>
      <el-table-column label="标题" prop="title" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column label="跳转类型" width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.jump_type === 1" type="warning">商品</el-tag>
          <el-tag v-else-if="scope.row.jump_type === 2" type="success">链接</el-tag>
          <el-tag v-else type="info">无</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="跳转值" prop="jump_val" min-width="140" show-overflow-tooltip></el-table-column>
      <el-table-column label="排序" prop="sort" width="80" sortable></el-table-column>
      <el-table-column label="启用" width="90">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.enable_switch"
            :active-value="1"
            :inactive-value="0"
            @change="onSwitch(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="openDialog(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="onDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      style="margin-top: 10px; text-align: right"
      background
      layout="total, prev, pager, next, sizes"
      :total="total"
      :current-page.sync="page"
      :page-size.sync="pageSize"
      :page-sizes="[10, 20, 50]"
      @current-change="loadList"
      @size-change="loadList"
    ></el-pagination>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="form.id ? '编辑 Banner' : '新增 Banner'" :visible.sync="dialogVisible" width="520px" @closed="resetForm">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="80px">
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="图片" prop="image">
           <img v-if="form.image" :src="form.image.startsWith('/')?`${baseURL}${form.image}`:form.image.startsWith('http')?`${form.image}`:`${baseURL}/${form.image}`" class="avatar"/>
           <el-button type="primary" @click="cover_upload" style="margin-top: 20px;">上传<i class="el-icon-upload el-icon--right"></i></el-button>
        </el-form-item>
        <el-form-item label="跳转类型">
          <el-radio-group v-model="form.jump_type">
            <el-radio :label="0">无跳转</el-radio>
            <el-radio :label="1">跳转商品</el-radio>
            <el-radio :label="2">外部链接</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.jump_type === 1" label="商品ID">
          <el-input v-model="form.jump_val" placeholder="填写商品ID"></el-input>
        </el-form-item>
        <el-form-item v-if="form.jump_type === 2" label="链接地址">
          <el-input v-model="form.jump_val" placeholder="https://..."></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort" :min="0" :max="9999"></el-input-number>
          <span style="color: #999; margin-left: 8px">数字越小越靠前</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="onSave">保存</el-button>
      </div>
    </el-dialog>

    <photo-center :photoCenterShow="photoCenterShow" :maxselected_num="maxselected_num" @closeDialog="closePhotoCenter"></photo-center>
  </div>
</template>

<script>
// import request from '@/api/request' // 按你的 request 文件路径改
import { bannerdelete,bannersave,bannerswitch,bannerlist,baseURL } from '../api/api';

import PhotoCenter from "../components/PhotoCenter/PhotoCenter.vue";
import { event_msg_keys } from '../eventbus/eventkeys.js';

export default {
  name: 'HomeBanner',
  components:{
    PhotoCenter
  },
  data() {
    return {
        baseURL,
      photoCenterShow:false,
      maxselected_num:1,
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 10,
      keyword: '',
      loading: false,
      saving: false,
      dialogVisible: false,
      uploadUrl: '/api/upload', // 你的上传接口
      form: {
        id: 0,
        title: '',
        image: '',
        jump_type: 0,
        jump_val: '',
        sort: 99,
        enable_switch: 1
      },
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        image: [{ required: true, message: '请上传图片', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.loadList()
    this.$evt.on(event_msg_keys.img_selected_submit_noti,this.img_selected_submit_callback)
  },
  destroyed(){
    this.$evt.off(event_msg_keys.img_selected_submit_noti,this.img_selected_submit_callback)
  },
  methods: {

    img_selected_submit_callback(e){
        console.log("img_selected_submit_callback:",e)
      const selected_imgs = e.imgs
      this.photoCenterShow = false
      this.form.image = selected_imgs[0].source
    },
    cover_upload(){
      console.log('cover_upload')
      this.photoCenterShow = true;
    },
    closePhotoCenter(){
      this.photoCenterShow = false;
    },
    async loadList() {
      this.loading = true
      try {
        const res = await bannerlist()

        console.log("bannerlist:",res)
        if (res && res.list) {
          this.tableData = res.list
          this.total = res.total
        }
      } catch (e) {
        this.$message.error(e || '加载失败')
      } finally {
        this.loading = false
      }
    },
    // 新增 / 编辑
    openDialog(row) {
      this.form = row
        ? { ...row }
        : { id: 0, title: '', image: '', jump_type: 0, jump_val: '', sort: 99, enable_switch: 1 }
      this.dialogVisible = true
    },
    resetForm() {
      if (this.$refs.formRef) this.$refs.formRef.clearValidate()
    },
    // 图片上传成功回调
    onUploadSuccess(res) {
      if (res.code === 0) {
        this.form.image = res.data.url // 按你的上传返回结构调整
        this.$message.success('上传成功')
      } else {
        this.$message.error(res.msg || '上传失败')
      }
    },
    async onSave() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return
        this.saving = true
        try {
            // id,title,image,jump_type,jump_val,sort,enable_switch
           const result = await bannersave(this.form)
        //   await request('/admin/home/banner/save', { ...this.form })
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.loadList()
        } catch (e) {
          this.$message.error(e || '保存失败')
        } finally {
          this.saving = false
        }
      })
    },
    // 开关
    async onSwitch(row) {
      try {

        const result = await bannerswitch({id:row.id,enable_switch:row.enable_switch})
  
        this.$message.success(row.enable_switch === 1 ? '已启用' : '已停用')
        
      } catch (e) {
        // 失败回滚开关状态
        row.enable_switch = row.enable_switch === 1 ? 0 : 1
        this.$message.error(e || '操作失败')
      }
    },
    onDelete(row) {
      this.$confirm(`确定删除Banner「${row.title || row.id}」?`, '提示', { type: 'warning' })
        .then(async () => {

            try {
                const result = await bannerdelete(row.id)
                this.$message.success('删除成功')
                this.loadList()
            } catch (error) {
                this.$message.error(`删除失败:${error}`)
            }
            
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.toolbar {
  overflow: hidden;
}
</style>